import Swiper from 'swiper/dist/js/swiper.js';
import Lottie from 'lottie-web';

export default class Home {
  init() {
    this._initNewsSwiper();
    this._initLottieAnimation();
  }

  _initNewsSwiper() {
      // const sectionElem = document.body.querySelector('section.section-social-feed');
      // const swiperElem = sectionElem.querySelector('.swiper-container');
      // let _this = this;

      const swiper = new Swiper('.social-feed-wrapper .swiper-container', {
        // initialSlide: 0,
        direction: 'horizontal',
        slidesPerView: 4,
        spaceBetween: 30,
        observer: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        breakpoints: {
          1200: {
            slidesPerView: 3,
            spaceBetween: 20
          },
          991: {
            slidesPerView: 2,
            spaceBetween: 10
          },
          767: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
        },
        // on: {
        //   init: function() {
        //     _this._initSwiperSlideNavigation.bind(this)();
        //     this.$el.addClass('initialized');
        //     setTimeout(function() {
        //       window.dispatchEvent(new Event('resize'));
        //     });
        //   },
        // },
      });
    }

    _initLottieAnimation() {
      let containerElem = document.body.querySelector('.illiustration-animated-img');
      let containerElemShield = document.body.querySelector('.illiustration-animation-wrapper-shield');
      let containerElemGlobe = document.body.querySelector('.illiustration-animation-wrapper-globe');
      let containerElemHexagon = document.body.querySelector('.illiustration-animation-wrapper-hexagon');

      Lottie.loadAnimation({
        container: containerElem, // the dom element that will contain the animation
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: './images/arweave-animation.data.json' // the path to the animation json
      });
      Lottie.loadAnimation({
        container: containerElemShield, // the dom element that will contain the animation
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: './images/arweave-animation-shield.data.json' // the path to the animation json
      });
      Lottie.loadAnimation({
        container: containerElemGlobe, // the dom element that will contain the animation
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: './images/arweave-animation-globe.data.json' // the path to the animation json
      });
      Lottie.loadAnimation({
        container: containerElemHexagon, // the dom element that will contain the animation
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: './images/arweave-animation-hexagon.data.json' // the path to the animation json
      });
    }

}
